<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-h4 text-center shades--text" style="color:#B56476;">
          TOP DESTINATIONS
        </div>
      </v-col>
      <v-col class="col-12 col-md-6 col-lg-3" v-for="p in pakets" :key="p">
        <package-item></package-item>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import PackageItem from "./PackageItem";
export default {
  data() {
    return {
      pakets: [1, 2, 3, 4]
    };
  },
  components: {
    PackageItem
  }
};
</script>

<style></style>
